import React from "react";
import PageHeader from "../../shared/components/PageHeader";

// Page-header definition for the legacy v1 Courses page. The page is a single
// list with no tabs and no header controls, so this is just the shared v2
// PageHeader carrying the title (and its full-width bottom border, which replaces
// the page's old title + divider).
export default function CoursesHeader() {
  return <PageHeader title="Courses" />;
}
